import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Auth relies on httpOnly cookies (set by the backend on login / Google session).
// Tokens are never stored in localStorage to avoid XSS token theft.
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export async function downloadDocument(doc) {
  const res = await api.get(`/documents/${doc.id}/download`, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = doc.original_filename || doc.title || "documento";
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1500);
}

export async function downloadZip({ employeeId, category } = {}) {
  const params = {};
  if (employeeId) params.employee_id = employeeId;
  if (category) params.category = category;
  const res = await api.get("/documents/download-zip", { params, responseType: "blob" });
  const cd = res.headers["content-disposition"] || "";
  const m = /filename="?([^"]+)"?/.exec(cd);
  const filename = m ? m[1] : "documenti.zip";
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1500);
}

export function formatBytes(bytes) {
  if (!bytes) return "—";
  const units = ["B", "KB", "MB", "GB"];
  let i = 0;
  let n = bytes;
  while (n >= 1024 && i < units.length - 1) {
    n /= 1024;
    i++;
  }
  return `${n.toFixed(n < 10 && i > 0 ? 1 : 0)} ${units[i]}`;
}

export const CATEGORIES = [
  { id: "buste_paga", label: "Buste Paga", icon: "FileText", badge: "bg-zinc-900 text-white border-zinc-900" },
  { id: "comunicazioni", label: "Comunicazioni", icon: "MessageSquare", badge: "bg-white text-zinc-700 border-zinc-300" },
  { id: "contratti", label: "Contratti & Moduli", icon: "ShieldCheck", badge: "bg-zinc-100 text-zinc-600 border-zinc-300" },
  { id: "altro", label: "Altro", icon: "Folder", badge: "bg-zinc-50 text-zinc-500 border-zinc-200" },
];

export function categoryMeta(id) {
  return CATEGORIES.find((c) => c.id === id) || CATEGORIES[3];
}

export const LOGO_URL =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_busta-paga-3/artifacts/q9tzi2tx_LINK%20S.R.L.S.png";
export const BRAND_SHORT = "LINK S.R.L.S";
export const BRAND_FULL = "LINK DI I.G.F — LINK S.R.L.S";
